import router from './router'

export default {
	moduleName: 'field',
  router
}



// WEBPACK FOOTER //
// ./src/core/modules/field/index.js